import { useState } from 'react'
import { VpIcon, VpIconButton } from '@vtmn-play/react'
import type { ActionChoiceDto } from '@/infra/api/generated/model'
import { CustomActionInput } from '@/src/components/actions/custom-action-input/CustomActionInput'
import { ActionChoiceButton } from './ActionChoiceButton'

type ActionChoiceItemProps = {
  actionChoice: ActionChoiceDto
  selected: boolean
  onActionClick: (action: ActionChoiceDto) => void
  onUpdateAction: (label: string) => void
  onActionDelete: (action: ActionChoiceDto) => void
}

export const ActionChoiceItem = ({
  actionChoice,
  selected,
  onActionClick,
  onUpdateAction,
  onActionDelete,
}: ActionChoiceItemProps) => {
  const [isEditing, setIsEditing] = useState(false)
  const handleValidateClick = (label: string) => {
    setIsEditing(false)
    onUpdateAction(label)
  }
  const handleDeleteClick = () => {
    setIsEditing(false)
    onActionDelete(actionChoice)
  }
  return (
    <div className="flex justify-between">
      {isEditing ? (
        <CustomActionInput
          action={actionChoice}
          onValidate={handleValidateClick}
          onDelete={handleDeleteClick}
        />
      ) : (
        <>
          <ActionChoiceButton
            actionChoice={actionChoice}
            selected={selected}
            onActionClick={onActionClick}
          />
          {actionChoice.isCustom && (
            <VpIconButton
              variantStyle="inverse"
              onClick={() => setIsEditing(true)}
              aria-label="Edit action"
            >
              <VpIcon name="edit" />
            </VpIconButton>
          )}
        </>
      )}
    </div>
  )
}
